module.exports = __webpack_public_path__ + "img/otkritost-mob-1.2dd95fee.png";